import { Popper, PopperContent, PopperTrigger } from '@cp/src/components/Popper/Popper';
import Typography from '@primitives/Typography';
import Button from '@navi/web-ui/lib/primitives/Button/Button';
import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';
import Modal from '@cp/src/components/Modal/Modal';
import PersonWithSeperatorIcon from '@cp/src/assets/icons/PersonWithSeprator';
import { ITelePhoneData } from '@cp/pages/CaseDetails/interfaces/CaseDetail.type';
import { copyToClipboard } from '@cp/src/utils/commonUtils';
import CrossNonfilledCircleIcon from '@cp/src/assets/icons/CrossNonfilledCircleIcon';
import { useState } from 'react';

const GlobalRoleAndNoFromLonghorn = ({ callData }: { callData: ITelePhoneData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const ProofOfSource = callData?.proofOfSource.proofOfSourceUrl;
  const isProofOfSourceAvailable = callData?.proofOfSource.isProofOfSourceAvailable;

  return (
    <>
      <Popper placement="left-end" hideStrategy="referenceHidden">
        <PopperTrigger>
          <PersonWithSeperatorIcon />
        </PopperTrigger>
        <PopperContent
          headerText="Added by"
          className="popperWrapper"
          arrowColor="var(--orange-oldlase)"
        >
          <div className="flex flex-col px-[12px] py-[8px] w-[286px] gap-[8px]">
            <div className="flex flex-row justify-between">
              <Typography variant="p3" className="text-sm" color="var(--grayscale-2)">
                Name
              </Typography>
              <Typography variant="p3" className="text-sm font-medium" color="var(--grayscale-2)">
                {callData?.createdByName || 'NA'}
              </Typography>
            </div>
            <div className="flex flex-row justify-between">
              <Typography variant="p3" className="text-sm " color="var(--grayscale-2)">
                Email
              </Typography>
              <div className="flex flex-row gap-[2px]">
                <Typography variant="p3" className="text-sm font-medium" color="var(--grayscale-2)">
                  {callData?.createdByEmail || 'NA'}
                </Typography>
                <Button
                  variant="text"
                  onClick={() => copyToClipboard(callData?.createdByEmail || '')}
                >
                  <CopyToClipboardIcon width={16} height={16} />
                </Button>
              </div>
            </div>
            {callData?.telephoneCustomerConfidence?.label ? (
              <>
                <div className="flex flex-row justify-between">
                  <Typography variant="p3" className="text-sm " color="var(--grayscale-2)">
                    Confidence
                  </Typography>
                  <div className="flex flex-row gap-[2px]">
                    <Typography
                      variant="p3"
                      className="text-sm font-medium"
                      color="var(--grayscale-2)"
                    >
                      {callData?.telephoneCustomerConfidence?.label || 'NA'}
                    </Typography>
                    <Button
                      variant="text"
                      onClick={() =>
                        copyToClipboard(callData?.telephoneCustomerConfidence?.label || '')
                      }
                    >
                      <CopyToClipboardIcon width={16} height={16} />
                    </Button>
                  </div>
                </div>
              </>
            ) : null}
            <div className="flex flex-row justify-between">
              <Typography variant="p3" className="text-sm" color="var(--grayscale-2)">
                Proof of source
              </Typography>
              <div className="flex flex-row gap-[2px]">
                {isProofOfSourceAvailable && ProofOfSource ? (
                  <Button variant="text" onClick={handleViewClick} className="!p-0 !h-auto">
                    View
                  </Button>
                ) : (
                  <div className="flex flex-row gap-1 items-center">
                    <CrossNonfilledCircleIcon />
                    <Typography
                      variant="p4"
                      className="text-sm font-medium"
                      color="var(--grayscale-3)"
                    >
                      Not available
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          </div>
        </PopperContent>
      </Popper>

      <Modal
        visible={isModalOpen && !!ProofOfSource}
        onClose={handleCloseModal}
        header={callData?.sourceText[0]}
        headerColor="var(--grayscale-3)"
        closeOnOutsideClick
        iconButtonSize="small"
        iconButtonVariant="borderless-secondary"
      >
        {ProofOfSource && (
          <img src={ProofOfSource} alt="Proof of source" className="max-w-[100%] max-h-[80vh]" />
        )}
      </Modal>
    </>
  );
};

export default GlobalRoleAndNoFromLonghorn;
